import { render, staticRenderFns } from "./Arena2D.vue?vue&type=template&id=4f0b4cec&"
import script from "./Arena2D.vue?vue&type=script&lang=js&"
export * from "./Arena2D.vue?vue&type=script&lang=js&"
import style0 from "./Arena2D.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports